import { useState } from "react";
import api from "@/lib/api";
import { Mail, Loader2, Check } from "lucide-react";

export default function NewsletterSignup({ source = "footer" }) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | loading | done
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setState("loading");
    try {
      await api.post("/newsletter/subscribe", { email, source });
      setState("done");
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong");
      setState("idle");
    }
  };

  if (state === "done") {
    return (
      <div className="flex items-center gap-2 text-sm text-emerald-400" data-testid="newsletter-success">
        <Check className="w-4 h-4" /> You're on the list — builder intel incoming.
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="w-full" data-testid="newsletter-form">
      <div className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-xl px-3 py-1.5 focus-within:border-cyan-500/50 transition-colors">
        <Mail className="w-4 h-4 text-slate-500 shrink-0" />
        <input
          type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="Get the weekly Builder Brief"
          className="bg-transparent text-sm text-slate-200 placeholder:text-slate-600 outline-none w-full"
          data-testid="newsletter-input"
        />
        <button type="submit" disabled={state === "loading"}
          className="shrink-0 text-xs font-semibold px-3 py-1.5 rounded-lg bg-cyan-500 hover:bg-cyan-400 text-slate-950 disabled:opacity-60"
          data-testid="newsletter-submit">
          {state === "loading" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : "Join"}
        </button>
      </div>
      {error && <p className="text-xs text-red-400 mt-1.5" data-testid="newsletter-error">{error}</p>}
    </form>
  );
}
